export default "__VITE_ASSET__t60x3AOS__"